import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { useAuth } from "../../auth/AuthProvider";
import { EMAIL_RE, ErrorSummary, Field } from "../../components/form";
import { useI18n } from "../../i18n/I18nProvider";
import type { MessageKey } from "../../i18n/messages";
import { AuthLayout } from "./AuthLayout";

export function ForgotPasswordPage() {
  const { t } = useI18n();
  const auth = useAuth();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [attempt, setAttempt] = useState(0);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (ev: FormEvent) => {
    ev.preventDefault();
    setAttempt((n) => n + 1);
    if (!EMAIL_RE.test(email.trim())) {
      setErrors({ email: "auth.errors.email" });
      return;
    }
    setErrors({});
    setBusy(true);
    const r = await auth.requestPasswordReset(email.trim());
    setBusy(false);
    // Same message whether or not the account exists (no account enumeration).
    if (r.ok || r.error === "auth.errors.generic") setSent(true);
    else setErrors({ form: r.error });
  };

  return (
    <AuthLayout title={t("auth.forgotTitle")}>
      {sent ? (
        <p role="status">{t("auth.forgotSent", { email: email.trim() })}</p>
      ) : (
        <form onSubmit={submit} noValidate>
          <ErrorSummary errors={errors} fieldIds={{ email: "forgot-email" }} focusKey={attempt} />
          <Field
            id="forgot-email"
            label={t("auth.email")}
            type="email"
            inputMode="email"
            autoComplete="email"
            value={email}
            error={errors.email ? t(errors.email as MessageKey) : null}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={busy}>
            {busy ? t("auth.working") : t("auth.submitForgot")}
          </button>
        </form>
      )}
      <p className="auth-switch">
        <Link to="/ingresar">{t("auth.backToLogin")}</Link>
      </p>
    </AuthLayout>
  );
}
